import React from 'react';
import { EarningsComponent } from './EarningsComponent';
import { NewsTicker } from './NewsTicker';

export const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <div className="home-header">
        <h1 className="home-title">Market Intelligence Dashboard</h1>
        <p className="home-subtitle">Real-time market data, earnings, and news</p>
      </div>

      <div className="home-grid">
        {/* Top Row - News Ticker */}
        <div className="home-section news-section">
          <div className="section-header">
            <h2 className="section-title">📰 Market News</h2>
          </div>
          <div className="section-content">
            <NewsTicker />
          </div>
        </div>

        {/* Bottom Row - Earnings Calendar */}
        <div className="home-section earnings-section">
          <div className="section-header">
            <h2 className="section-title">📊 Earnings Calendar</h2>
            <p className="section-subtitle">Latest earnings reports and estimates</p>
          </div>
          <div className="section-content">
            <EarningsComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
